module.exports = __webpack_public_path__ + "static/media/2-GJALTE.12b1ccfd.mp3";